import React from 'react';
import image from '../Images/Me.jpg';

const Banner = () => {
    return (
        <div className='bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500'>
            <h1 className='bg-clip-text text-transparent bg-gradient-to-r from-red-500 via-yellow-500 to-blue-500 text-5xl font-bold pt-9'>Welcome To My Personal Portfolio</h1>

            <div className="hero min-h-screen">
                <div className="hero-content flex-col lg:flex-row-reverse">
                   <div className='flex-1 lg:pl-28'>
                   <img src={image} className="mask mask-decagon h-96" />
                   </div>
                    <div className='flex-1'>
                        <p className='text-white'>Web Developer</p>
                        <h1 className="text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-red-500 via-yellow-500 to-blue-500">Sarfaraj Shaikat</h1>
                        <p className="py-6 text-slate-300">Being a fresher, I think I am very flexible and adaptive to learning new things. I am sure I will be able to contribute something capable for the growth of the company. My last project in Operations has taught me how to be a team player, and work in unison. I am sure that is a valuable quality which I will be bringing to the table. I will follow the company guidelines and always play by the rulebooks.</p>
                        <button type="button" className=" btn bg-gradient-to-r from-green-400 to-blue-500 hover:from-pink-500 hover:to-yellow-500 text-slate-100 border-none">
                            <a target='blank' href="https://drive.google.com/file/d/1Htrlz6MnyjcfkQ_995OLuzbnW1l-D8KU/view">Download Resume </a>
                        </button>
                    </div>
                </div>
            </div>



        </div>
    );
};

export default Banner;